import { AxiosInstance } from 'axios';
import { GroupReservationService } from 'services/Reservations';

export interface GroupReservationServiceType {
  getAll: ReturnType<typeof GroupReservationService.getAll>;
  getAllConfirmation: ReturnType<typeof GroupReservationService.getAllConfirmation>;
  getById: ReturnType<typeof GroupReservationService.getById>;
  updateRooms: ReturnType<typeof GroupReservationService.updateRooms>;
  update: ReturnType<typeof GroupReservationService.update>;
  splitGroup: ReturnType<typeof GroupReservationService.splitGroup>;
  saveRooming: ReturnType<typeof GroupReservationService.saveRooming>;
  addRoom: ReturnType<typeof GroupReservationService.addRoom>;
  removeRoom: ReturnType<typeof GroupReservationService.removeRoom>;
  removeGroupReservation: ReturnType<typeof GroupReservationService.removeGroupReservation>;
}

export const initGroupReservationService = (axios: AxiosInstance): GroupReservationServiceType => ({
  getAll: GroupReservationService.getAll(axios),
  getAllConfirmation: GroupReservationService.getAllConfirmation(axios),
  getById: GroupReservationService.getById(axios),
  updateRooms: GroupReservationService.updateRooms(axios),
  update: GroupReservationService.update(axios),
  splitGroup: GroupReservationService.splitGroup(axios),
  saveRooming: GroupReservationService.saveRooming(axios),
  addRoom: GroupReservationService.addRoom(axios),
  removeRoom: GroupReservationService.removeRoom(axios),
  removeGroupReservation: GroupReservationService.removeGroupReservation(axios),
});
